module.exports = __webpack_public_path__ + "media/images/stitcher-5cc2884084d1dcc29504b7698be88d89.png";